import { Box, Paper } from "@mui/material";
import { OrbLoader, PageHeader } from "@components/ui_v2";

/**
 * Pantalla de marcador de posición para `PreparandoContratos` en productos sin pantalla dedicada todavía.
 */
export const PreparandoContratosPendiente = () => (
  <Box>
    <PageHeader
      eyebrow="Formalización · Generación de contratos"
      title="Estamos preparando tus contratos"
      subtitle="Generamos los documentos contractuales con los datos validados de tu expediente. Te notificaremos cuando estén listos."
    />

    <Paper variant="lendia_paper" sx={{ display: "flex", justifyContent: "center", p: "56px 24px" }}>
      <OrbLoader />
    </Paper>
  </Box>
);
